import { SessionHistoryRequest, SessionHistoryResponse } from '../../models/RailsDto';

const generateErrorResponse = (error?: Error): SessionHistoryResponse => {
  return {
    data: {
      check_session: null,
    },
    result: {
      status: error ? 500 : 200,
      message: '',
    },
  };
};

export default async function checkRailsSessionHistory({
  apiAccessToken,
}: Partial<SessionHistoryRequest>): Promise<SessionHistoryResponse> {
  if (!apiAccessToken) {
    return generateErrorResponse();
  }

  try {
    const apiEndpoint = `https://api.${process.env.TARGET_ENV_PREFIX}myrealtrip.com/front/session-history`;
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-access-token': apiAccessToken || '',
      },
    });

    if (!response?.ok) {
      throw new Error(`HTTP error! Status: ${response?.status}`);
    }

    return await response.json();
  } catch (error) {
    return generateErrorResponse(error as Error);
  }
}
